import React from "react";
import { Helmet } from "react-helmet-async";
import LoginSignUp from "../Components/Authentication/LoginSign/LoginSignUp";
import { useSiteSeo } from "../context/SiteSeoContext";
import { usePageSeo } from "../hooks/usePageSeo";

const Authentication = () => {
  const siteCtx = useSiteSeo();
  const { seo_title, seo_description, robots } = usePageSeo('login');
  const siteName = siteCtx.organization_name?.trim() || 'Gem Fashion Studios';

  return (
    <>
      <Helmet>
        <title>{seo_title || `Sign In / Register | ${siteName}`}</title>
        <meta name="description" content={seo_description || `Sign in or create your account at ${siteName} to track rentals, manage bookings, and explore exclusive collections.`} />
        <meta name="robots" content={robots || 'noindex,nofollow'} />
      </Helmet>
      <LoginSignUp />
    </>
  );
};

export default Authentication;
